"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendar_de_de = void 0;
function calendar_de_de() {
    return {
        "calendars.navigation.title": "Kalender",
        "calendars.navigation.subtitle": "Erstellen Sie eigene Kalender und Kalendereinträge.",
        "calendars.overview.title": "Alle Kalender",
        "calendars.creation.title": "Neuen Kalender erstellen",
        "calendars.editor.title": "Kalender bearbeiten",
        "calendars.entries.create": "Event erstellen",
        "calendars.entries.edit": "Event bearbeiten",
        "calendars.entries.creation.errors.calendarnotfound": "Kalender nicht gefunden",
        "calendars.entries.creation.errors.nocalendargiven": "Kein Kalender angegeben",
        "calendars.actions.createcalendar": "Kalender erstellen",
        "calendars.config.labels.headline": "Konfiguration Kalenderzeiten",
        "calendars.config.labels.description": "Bestimmen Sie hier die Start- und Endzeit Ihres Kalenders.",
        "calendars.config.labels.starttime.title": "Startzeit",
        "calendars.config.labels.starttime.description": "Geben Sie die Zeit ein, an welcher der Kalender starten soll. Format: hh:mm:ss, z.B.: '08:00:00'",
        "calendars.config.labels.endtime.title": "Endzeit",
        "calendars.config.labels.endtime.description": "Geben Sie die Zeit ein, an welcher der Kalender enden soll. Format: hh:mm:ss, z.B.: '22:00:00'",
        "calendars.config.errors.timeformat.title": "Falsches Zeitformat",
        "calendars.config.errors.timeformat.message": "Bitte geben Sie in der Konfiguration die Start und Endzeit Ihres Kalenders im Format 'hh:mm:ss' an."
    };
}
exports.calendar_de_de = calendar_de_de;
